import React from 'react';
import { styled, css } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import Button from '@atlaskit/button/standard-button';
import { N0, N80 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const StyledActionButton = styled(Button)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
	'&&': {
		// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-dynamic-styles
		color: (props: any) =>
			props.isSelected ? token('color.text.inverse', N0) : token('color.text.subtlest', N80),
		minWidth: '32px',
	},
});

type ActionButtonWrapperProps = {
	forceShow?: boolean;
	children: React.ReactNode;
};

const actionButtonWrapperStyle = css({
	transition: 'ease-in 150ms',
	opacity: 'var(--show-action)',
});

const forceShowStyle = css({
	opacity: '1',
});

export const ActionButtonWrapper = (props: ActionButtonWrapperProps) => (
	<div css={[actionButtonWrapperStyle, props?.forceShow && forceShowStyle]} {...props} />
);
